<template>
    <div class="popup" :class="{active: popup}">
        <div class="popup_dimmer">
            <div class="popup_content">
                
                <a href="#0" class="closeBtn" @click.prevent="togglePopup()">
                    <ion-icon name="close-circle"></ion-icon>
                </a>
                
                <div class="popup_image image" style="background-image:url(https://images.prismic.io/vanmglcom/9104edec-f2e6-4e9e-9824-bc1db5264e2b_f450b196630667.5eb2bfd323956.jpg?auto=compress,format);"></div>

                <div class="popup_content_inner">
                    
                    <!--Phone Number-->
                    <form v-if="type === 'phoneNumber'" class="formArea">
                        
                        <div v-if="!success">
                            <h2 class="popup_title">Phone Number Missing</h2>
                            <p class="popup_desc">We would like to send you event notifications via sms. Please add your phone number.</p>
                            <input v-if="!loading" v-model.trim="userPhoneNumber" type="tel" minlength="10" maxlength="10" placeholder="Phone Number (10 digits)" :class="{error: validPhone === false}" />
                            <input v-if="!loading" @click.prevent="addPhoneNumber()" type="submit" value="Update" class="btn green" />
                            <div v-if="loading" class="loading small no-margin"></div>
                        </div>
                        <p v-else class="success">Successfully updated and sent a text message.</p>
                    </form>

                    <!--Email Address-->
                    <form v-if="type === 'email'" class="formArea">

                        <div v-if="!success">
                            <h2 class="popup_title">Email Address</h2>
                            <p class="popup_desc">We would like to send you event notifications via email. Please add your email address.</p>
                            <input v-if="!loading" v-model.trim="userEmail" type="email" placeholder="Email Address" :class="{error: validEmail === false}" />
                            <input v-if="!loading" @click.prevent="addEmail()" type="submit" value="Update" class="btn green" />
                            <div v-if="loading" class="loading small no-margin"></div>
                        </div>
                        <p v-else class="success">Successfully updated email.</p>
                        
                    </form>

                    <!--Locations-->
                    <form v-if="type === 'location'" class="formArea">

                        <div v-if="!success">
                            <h2 class="popup_title">Location</h2>
                            <p class="popup_desc">OneMgl will be expanding to other cities around Canada. Soon, you will be able to join events in other cities. Please select your current location.</p>
                            
                            <select v-if="!loading" v-model="userCountry" @change.prevent="toggleCountry">
                                <option value="">-- Select Country --</option>
                                <option value="CA">Canada</option>
                                <option value="US">United States</option>
                            </select>
                            
                            <select v-if="!loading && allStates !== null && userCountry !== ''" v-model="userState" @change.prevent="toggleStates">
                                <option value="">-- Select State --</option>
                                <option v-for="(state, index) in allStates" :key="index" :value="state.id">{{ state.name }}</option>
                            </select>

                            <select v-if="!loading && allCities !== null && userState !== ''" v-model="userCity">
                                <option value="">-- Select City --</option>
                                <option v-for="(city, index) in allCities" :key="index" :value="city.id">{{ city.name }}</option>
                            </select>
                            
                            <input v-if="!loading && userCountry !== '' && userState !== '' && userCity !== ''" @click.prevent="updateLocation" type="submit" value="Update Location" class="btn green" />
                            
                            <div v-if="loading" class="loading small no-margin"></div>
                        </div>
                        <p v-else class="success">Successfully updated location.</p>
                    </form>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import countryData from 'country-state-city'
    const fb = require('../firebaseConfig.js')

    export default {
        data(){
            return{
                popup: false,
                type: '',
                userPhoneNumber: '',
                userEmail: '',
                validPhone: null,
                validEmail: null,
                loading: false,
                success: false,
                userCountry: '',
                userState: '',
                userCity: '',
                allStates: null,
                allCities: null,
                userProfile: null
            }
        },
        created(){
            let self = this

            document.addEventListener('keyup', function (evt) {
                if (evt.keyCode === 27) {
                    self.popup = false
                }
            })
        },
        mounted(){
            let self = this

            // let locationLocalStorage = window.localStorage.getItem('locationCheck2')
            // let phoneLocalStorage = window.localStorage.getItem('phoneNumberCheck')
            // let emailLocalStorage = window.localStorage.getItem('emailCheck')

            // Members Only
            // console.log('User profile: ', self.$store.state.userProfile, self.$store.state.isMember)

            if(self.$store.state.currentUser !== null){
                if(self.$store.state.userProfile !== null){
                    
                    // Check Phone Number
                    if(self.$store.state.userProfile.phoneNumber === null || typeof(self.$store.state.userProfile.phoneNumber) === 'undefined'){
                        self.type = 'phoneNumber'
                        self.popup = true
                    }
                    
                    // Check Location
                    if(self.popup === false){
                        if(self.$store.state.userProfile.location === null || typeof(self.$store.state.userProfile.location) === 'undefined'){
                            self.type = 'location'
                            self.popup = true
                        }else if(self.$store.state.userProfile.location.city === null || typeof(self.$store.state.userProfile.location.city) === 'undefined'){
                            self.type = 'location'
                            self.popup = true
                        }
                    }

                    // Check Email
                    if(self.popup === false){
                        if(self.$store.state.userProfile.email === null || typeof(self.$store.state.userProfile.email) === 'undefined'){
                            self.type = 'email'
                            self.popup = true
                        }
                    }
                }
            }
        },
        methods: {
            toggleCountry(){
                if(this.userCountry === 'CA'){
                    this.allStates = countryData.getStatesOfCountry('38')
                    this.userState = ''
                    this.userCity = ''
                }else if(this.userCountry === 'US'){
                    this.allStates = countryData.getStatesOfCountry('231')
                    this.userState = ''
                    this.userCity = ''
                }
            },
            toggleStates(){
                this.allCities = countryData.getCitiesOfState(this.userState)
                this.userCity = ''
            },
            togglePopup(){
                if(this.popup === true){
                    this.popup = false
                    // if(this.type === 'phoneNumber'){
                    //     window.localStorage.setItem('phoneNumberCheck', true)
                    // }
                    // if(this.type === 'email'){
                    //     window.localStorage.setItem('emailCheck', true)
                    // }
                    // if(this.type === 'location'){
                    //     window.localStorage.setItem('locationCheck2', true)
                    // }
                }else{
                    this.popup = true
                }
            },
            addPhoneNumber(){

                this.loading = true

                if(this.userPhoneNumber !== null && this.userPhoneNumber !== '' && this.userPhoneNumber.length === 10){
                    this.validPhone = true
                }else{
                    this.validPhone = false
                    this.loading = false
                }

                if(this.validPhone){

                    let userRef = fb.usersCollection.doc(this.$store.state.currentUser.uid)
                    let updates = {
                        phoneNumber: this.userPhoneNumber,
                        settings: this.$store.state.userProfile.settings
                    }
                    updates.settings.sendTxt = true

                    userRef.update(updates).then(() => {
                        
                        window.localStorage.setItem('phoneNumberCheck', true)
                        this.sendTestMessage()

                    }).catch(err => {
                        this.loading = false
                        alert('Error updating phone: ', err.message)
                    })
                }
            },
            sendTestMessage(){

                let self = this

                self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/SendTxt', {
                    phoneNumber: self.userPhoneNumber,
                    message: 'OneMgl - Hi '+ self.$store.state.userProfile.firstName +', you have successfully subscribed to OneMgl sms event notifications!'
                }).then(response => {
                    if(response.status === 200){

                        self.loading = false
                        self.success = true
                    }
                })
                .catch((err) => {
                    alert('Error sending test message ', err.message)
                    self.loading = false
                })
            },
            addEmail(){

                let self = this
                const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                
                self.loading = true

                if(this.userEmail !== null && this.userEmail !== '' && this.userEmail.match(emailRegex)){
                    this.validEmail = true
                }else{
                    this.validEmail = false
                    this.loading = false
                }

                if(this.validEmail){

                    let userRef = fb.usersCollection.doc(this.$store.state.currentUser.uid)
                    let updates = {
                        email: this.userEmail
                    }

                    userRef.update(updates).then(() => {
                        
                        window.localStorage.setItem('emailCheck', true)

                        self.loading = false
                        self.success = true

                    }).catch(err => {
                        this.loading = false
                        alert('Error updating email: ', err.message)
                    })
                }
            },
            updateLocation(){

                let userRef = fb.usersCollection.doc(this.$store.state.currentUser.uid)

                this.loading = true

                let updates = {
                    location: {
                        'country': countryData.getCountryByCode(this.userCountry),
                        'state': countryData.getStateById(this.userState),
                        'city': countryData.getCityById(this.userCity)
                    }
                }

                userRef.update(updates).then(() => {
                    
                    this.loading = false
                    this.success = true

                }).catch(err => {

                    this.loading = false

                    console.log('Error updating location: ', err.message)
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Popups.vue